<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Chat Channels</a>
    <div class="ms-auto d-flex gap-2 align-items-center flex-wrap justify-content-end">
      <!-- Server Selector -->
      <select class="form-select form-select-sm" [(ngModel)]="selectedServerId" style="width: auto; min-width: 160px;"
        *ngIf="hasActiveServers()">
        <option [ngValue]="null" disabled>Select Server</option>
        <option *ngFor="let s of servers" [ngValue]="s.id">{{ s.ip_address || s.hostname || ('Server #' + s.id) }}</option>
      </select>
      <button class="btn btn-sm btn-outline-info" (click)="connectTelegramWeb()" [disabled]="!hasActiveServers()">&#43; TG Web</button>
      <button class="btn btn-sm btn-outline-primary" (click)="connectTelegram()" [disabled]="!hasActiveServers()">&#43; TG Bot</button>
      <button class="btn btn-sm btn-outline-success" (click)="initWhatsApp()" [disabled]="!hasActiveServers()">&#43; WA</button>
    </div>
  </div>
</nav>
<hr />

<!-- No active servers alert -->
<div class="container-fluid" *ngIf="!loading && !hasActiveServers()">
  <div class="alert alert-warning">
    <strong>No active MultiChat Server found.</strong> You need a dedicated server before adding channels.
    <a [routerLink]="['/lo', company_uuid, 'multichat-server']" class="alert-link">Go to MultiChat Servers</a> to purchase one.
  </div>
</div>

<!-- Telegram Token Form -->
<div class="container-fluid" *ngIf="showTelegramForm">
  <div class="card mb-3">
    <div class="card-body">
      <h6 class="card-title">Connect Telegram Bot</h6>
      <p class="text-muted small">Get a bot token from <a href="https://t.me/BotFather" target="_blank">&#64;BotFather</a> on Telegram.</p>
      <div class="row g-2 align-items-end">
        <div class="col-md-3">
          <label class="form-label">Name</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="telegramName" placeholder="e.g. Support Bot" />
        </div>
        <div class="col-md-5">
          <label class="form-label">Bot Token</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="telegramToken" placeholder="123456:ABC-DEF..." />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-primary" (click)="submitTelegram()" [disabled]="telegramConnecting || !telegramToken.trim()">
            {{ telegramConnecting ? 'Connecting...' : 'Connect' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTelegramForm()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Telegram Web Auth Form (multi-step) -->
<div class="container-fluid" *ngIf="showTelegramWebForm">
  <div class="card mb-3 border-info">
    <div class="card-body">
      <h6 class="card-title">Connect Web Telegram (User Account)</h6>
      <p class="text-muted small">Login with a real Telegram account. Get API credentials from <a href="https://my.telegram.org" target="_blank">my.telegram.org</a>.</p>

      <!-- Step 1: API credentials -->
      <div *ngIf="!tgWebChannelId" class="row g-2 align-items-end">
        <div class="col-md-2">
          <label class="form-label">Name</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgWebName" placeholder="Telegram Web" />
        </div>
        <div class="col-md-2">
          <label class="form-label">API ID</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgWebApiId" placeholder="12345678" />
        </div>
        <div class="col-md-4">
          <label class="form-label">API Hash</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgWebApiHash" placeholder="abc123def456..." />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTelegramWebInit()" [disabled]="tgWebConnecting || !tgWebApiId.trim() || !tgWebApiHash.trim()">
            {{ tgWebConnecting ? 'Initializing...' : 'Next' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTelegramWebForm()">Cancel</button>
        </div>
      </div>

      <!-- Step 2: Phone number -->
      <div *ngIf="tgWebChannelId && tgWebAuthState === 'awaiting_phone'" class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label">Phone Number (with country code)</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgWebPhone" placeholder="+60123456789" />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTelegramWebPhone()" [disabled]="tgWebConnecting || !tgWebPhone.trim()">
            {{ tgWebConnecting ? 'Sending...' : 'Send Code' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTelegramWebForm()">Cancel</button>
        </div>
      </div>

      <!-- Step 3: Auth code -->
      <div *ngIf="tgWebChannelId && tgWebAuthState === 'awaiting_code'" class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label">Auth Code (check your Telegram app)</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="tgWebCode" placeholder="12345" autocomplete="off" />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTelegramWebCode()" [disabled]="tgWebConnecting || !tgWebCode.trim()">
            {{ tgWebConnecting ? 'Verifying...' : 'Verify Code' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTelegramWebForm()">Cancel</button>
        </div>
      </div>

      <!-- Step 4: 2FA password -->
      <div *ngIf="tgWebChannelId && tgWebAuthState === 'awaiting_password'" class="row g-2 align-items-end">
        <div class="col-md-5">
          <label class="form-label">2FA Password</label>
          <input type="password" class="form-control form-control-sm" [(ngModel)]="tgWebPassword" placeholder="Your 2FA password" />
        </div>
        <div class="col-md-4 d-flex gap-2">
          <button class="btn btn-sm btn-info" (click)="submitTelegramWebPassword()" [disabled]="tgWebConnecting || !tgWebPassword.trim()">
            {{ tgWebConnecting ? 'Verifying...' : 'Submit' }}
          </button>
          <button class="btn btn-sm btn-outline-secondary" (click)="cancelTelegramWebForm()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="text-center py-3" *ngIf="loading">Loading...</div>

  <div class="alert alert-info" *ngIf="!loading && channels.length === 0">
    No channels configured. Click <strong>+ WhatsApp</strong>, <strong>+ Telegram Bot</strong>, or <strong>+ Web Telegram</strong> to get started.
  </div>

  <div class="table-responsive" *ngIf="channels.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th style="width:40px">#</th>
          <th>Channel</th>
          <th>Name</th>
          <th>Server</th>
          <th>Status</th>
          <th>Connection</th>
          <th>Created</th>
          <th style="width:200px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ch of channels; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <span class="me-1">{{ getChannelIcon(ch.channel) }}</span>
            <span class="text-capitalize">{{ ch.channel === 'telegram_web' ? 'Telegram Web' : ch.channel }}</span>
          </td>
          <td>
            <!-- Normal display -->
            <span *ngIf="editingId !== ch.id">{{ ch.name }}</span>
            <!-- Inline edit -->
            <div class="d-flex align-items-center gap-1" *ngIf="editingId === ch.id">
              <input type="text" class="form-control form-control-sm" [(ngModel)]="editingName"
                (keydown.enter)="saveEdit(ch)" (keydown.escape)="cancelEdit()" style="max-width: 200px" />
              <button class="btn btn-sm btn-success px-2" (click)="saveEdit(ch)" title="Save">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                </svg>
              </button>
              <button class="btn btn-sm btn-outline-secondary px-2" (click)="cancelEdit()" title="Cancel">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
              </button>
            </div>
          </td>
          <td>
            <span class="small text-muted" *ngIf="ch.server_ip">{{ ch.server_ip }}</span>
            <span class="small text-muted" *ngIf="!ch.server_ip">—</span>
          </td>
          <td>
            <span class="badge" [ngClass]="ch.status === 1 ? 'bg-success' : 'bg-secondary'">
              {{ ch.status === 1 ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>
            <span class="badge" [ngClass]="getStatusBadgeClass(ch.connection_status)">
              {{ ch.connection_status }}
            </span>
          </td>
          <td>{{ ch.create_on | date:'dd-MM-yyyy HH:mm' }}</td>
          <td>
            <div class="d-flex gap-1 flex-wrap">
              <!-- Edit -->
              <button class="btn btn-sm btn-outline-primary" (click)="startEdit(ch)" *ngIf="editingId !== ch.id"
                title="Edit name">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                  <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                </svg>
              </button>

              <!-- QR -->
              <button *ngIf="ch.channel === 'whatsapp' && ch.connection_status === 'qr_needed'"
                class="btn btn-sm btn-outline-primary"
                [routerLink]="['/lo', company_uuid, 'whatsapp']"
                [queryParams]="{channel_id: ch.id}">
                QR
              </button>

              <!-- Disconnect -->
              <button *ngIf="ch.connection_status === 'connected'"
                class="btn btn-sm btn-outline-warning"
                (click)="disconnectChannel(ch)">
                Disconnect
              </button>

              <!-- Connect -->
              <button *ngIf="ch.connection_status !== 'connected' && ch.channel === 'whatsapp'"
                class="btn btn-sm btn-outline-success"
                (click)="initWhatsApp(ch.id)">
                Connect
              </button>
              <button *ngIf="ch.connection_status !== 'connected' && ch.channel === 'telegram'"
                class="btn btn-sm btn-outline-primary"
                (click)="connectTelegram(ch.id)"
                [disabled]="telegramConnecting">
                Connect
              </button>
              <button *ngIf="ch.connection_status !== 'connected' && ch.channel === 'telegram_web'"
                class="btn btn-sm btn-outline-info"
                (click)="connectTelegramWeb(ch.id)"
                [disabled]="tgWebConnecting">
                Connect
              </button>

              <!-- Delete -->
              <button class="btn btn-sm btn-outline-danger" (click)="deleteChannel(ch)" title="Delete channel">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                  <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3V2h11v1z"/>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
